<template>
  <v-dialog
    scollable
    :scrim="true"
    :max-width="698"
    v-on:keydown.stop
    v-model="open"
  >
    <v-card class="dialog-card">
      <div class="dialog-card-body">
        <h2 class="dialog-title">Subscription canceled</h2>
        <p class="dialog-description">Your subscription to NuBuilder {{ selectedPlan?.name }} has been canceled. Thank you
          for using NuBuilder.
          We hope to see you again
          soon!</p>
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          @click="open = false"
        >
          Done
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { getPlanByPriceId } from '@/utils/payments'

export default {
  computed: {
    ...mapState({
      activeSubscription: state => state.payments.activeSubscription
    }),
    selectedPlan: function () {
      if (this.activeSubscription) {
        return getPlanByPriceId(this.activeSubscription?.subscriptionDetails?.price?.id)
      }
      return null
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    openDialog () {
      this.open = true
    }
  }
}
</script>

<style scoped>
.dialog-card {
  padding: 16px;
  min-height: 455px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-card-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.dialog-title {
  font-size: 36px;
  padding: 0 16px;
  font-weight: 400;
  color: #000000;
  font-style: normal;
  text-align: center;
  line-height: 44px;
  margin-bottom: 40px;
}

.dialog-description {
  font-size: 20px;
  padding: 0 16px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 40px;
  line-height: 24px;
  color: var(--dark-4, #363A40);
}
</style>
